require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-danny-sperry.json") })
        }
      }, "path---blog-author-danny-sperry");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-danny-sperry!./.cache/json/blog-author-danny-sperry.json
// module id = 623
// module chunks = 231608221292675